import { NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TrackByFunction } from "@angular/core";
import { CarouselModule } from "src/app/common/components/tpm-carousel/carousel.module";
import { CommunalPlatformNewsEntry, NetzeBwNewsEntry } from "../../../news/news.interfaces";
import { LaunchpadMarketplaceBannerProps, LaunchpadType } from "../../container/launchpad.interfaces";
import { MarketplaceCarouselItemComponent } from "./marketplace-carousel-item/marketplace-carousel-item.component";
import { NewsCarouselItemComponent } from "./news-carousel-item/news-carousel-item.component";

@Component({
  selector: "tpm-news-carousel",
  templateUrl: "news-carousel.component.html",
  styleUrls: ["news-carousel.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgFor, CarouselModule, NewsCarouselItemComponent, MarketplaceCarouselItemComponent]
})
export class NewsCarouselComponent {
  @Output() readonly newsItemClicked = new EventEmitter<NetzeBwNewsEntry | CommunalPlatformNewsEntry>();
  @Output() readonly marketplaceItemClicked = new EventEmitter<LaunchpadMarketplaceBannerProps>();

  @Input() marketplaceList: Array<any> | undefined;
  @Input() newsList: Array<any> | undefined;
  @Input() overlay: LaunchpadType;
  @Input() isMobile: boolean | undefined;

  public readonly trackByIndex: TrackByFunction<unknown> = (index) => index;
}
